import { useQuery } from '@tanstack/react-query';

import { ApiRoutes, QueryKeyEnum, TimeEnum } from '@lib/enums';
import { useHttp } from '@lib/http';

import type { TUser } from '@models/authorization/TUser';
import type { UseQueryResult } from '@tanstack/react-query';

export function useQueryGetMyUser(
  options: object = {},
): UseQueryResult<TUser & { bannedTfnAreaCodes: string[] }, Error> {
  const { http } = useHttp();

  return useQuery({
    queryKey: [QueryKeyEnum.MyUser],
    queryFn: async () => {
      const data = await http.get(ApiRoutes.Users.Mine).sendx<TUser>();

      return { ...data, bannedTfnAreaCodes: ['229', '800', '888'] };
    },
    staleTime: TimeEnum.TwelveHours,
    ...options,
  });
}
